<template>
  <span class="me-1" v-if="isShowTagsBtn() && isPage.articles()">
     <router-link class="btn btn-primary" :to="{name: 'PostTags'}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-tags"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 8v4.172a2 2 0 0 0 .586 1.414l5.71 5.71a2.41 2.41 0 0 0 3.408 0l3.592 -3.592a2.41 2.41 0 0 0 0 -3.408l-5.71 -5.71a2 2 0 0 0 -1.414 -.586h-4.172a2 2 0 0 0 -2 2" /><path d="M18 19l1.592 -1.592a4.82 4.82 0 0 0 0 -6.816l-4.592 -4.592" /><path d="M7 10h-.01" /></svg>
        Теги
      </router-link>
  </span>
  <span class="me-1" v-if="isShowPermissionBtn() && isPage.posts()">
     <PermissionsGroup :data='{
        user_filter: {
          roles: [editorRoleId],
        },
       category: "channels",
       object_id: fields.channel_id,
     }' />
  </span>
  <span class="me-1" v-if="isShowCreateBtn()">
    <span class="btn-group">
       <router-link class="btn btn-primary" :to="{name: 'PostCreate', params: {channel_id: fields.channel_id}, query: {type_id: functions.getTypeId()}}">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <circle cx="12" cy="12" r="9"></circle>
          <line x1="9" y1="12" x2="15" y2="12"></line>
          <line x1="12" y1="9" x2="12" y2="15"></line>
        </svg>
        Создать
      </router-link>

      <button
              type="button"
              class="btn btn-primary dropdown-toggle dropdown-toggle-split"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              v-if="isShowDropDownInCreateBtn()"
          >
            <span class="visually-hidden">Выбрать</span>
      </button>
      <span class="dropdown-menu p-2" v-if="isShowDropDownInCreateBtn()">
        <router-link
            class="btn btn-sm mb-1 d-flex align-items-center justify-content-start"
            :to="{ name: 'PostCreate', params: { channel_id: fields.channel_id }, query: { type_id: 6 } }"
        >
            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <circle cx="12" cy="12" r="9"></circle>
              <line x1="9" y1="12" x2="15" y2="12"></line>
              <line x1="12" y1="9" x2="12" y2="15"></line>
            </svg>
          Скидку
        </router-link>

        <router-link
            class="btn btn-sm mb-1 d-flex align-items-center justify-content-start"
            :to="{ name: 'PostCreate', params: { channel_id: fields.channel_id }, query: { type_id: 7 } }"
        >
             <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <circle cx="12" cy="12" r="9"></circle>
              <line x1="9" y1="12" x2="15" y2="12"></line>
              <line x1="12" y1="9" x2="12" y2="15"></line>
            </svg>
          Промокод
        </router-link>

        <router-link
            class="btn btn-sm mb-1 d-flex align-items-center justify-content-start"
            :to="{ name: 'PostCreate', params: { channel_id: fields.channel_id }, query: { type_id: 5 } }"
        >
             <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <circle cx="12" cy="12" r="9"></circle>
              <line x1="9" y1="12" x2="15" y2="12"></line>
              <line x1="12" y1="9" x2="12" y2="15"></line>
            </svg>
          Заметку
        </router-link>
        <router-link
            class="btn btn-sm d-flex align-items-center justify-content-start"
                 :to="{ name: 'PostCreate', params: { channel_id: fields.channel_id }, query: { type_id: 15 } }"
             >
             <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
              <circle cx="12" cy="12" r="9"></circle>
              <line x1="9" y1="12" x2="15" y2="12"></line>
              <line x1="12" y1="9" x2="12" y2="15"></line>
            </svg>
          Статью
        </router-link>
      </span>
    </span>
  </span>
  <span class="d-inline-block me-1 mt-1 mt-sm-0">
    <template v-if="isPage.posts()">
      <router-link class="btn btn-dark" :to="{name: 'PostsDrafts', params: {channel_id: fields.channel_id}}">
        Черновики
      </router-link>
    </template>
    <template v-if="isPage.notes()">
      <router-link class="btn btn-dark" :to="{name: 'NotesDrafts'}">
        Черновики
      </router-link>
    </template>
    <template v-if="isPage.promocode()">
      <router-link class="btn btn-dark" :to="{name: 'PromocodeDrafts'}">
        Черновики
      </router-link>
    </template>
    <template v-if="isPage.articles()">
      <router-link class="btn btn-dark" :to="{name: 'ArticlesDrafts'}">
        Черновики
      </router-link>
    </template>
    <template v-if="isPage.postsDrafts()">
      <router-link class="btn btn-dark" :to="{name: 'Posts', params: {channel_id: fields.channel_id}}">
        Посты
      </router-link>
    </template>
    <template v-if="isPage.promocodeDrafts()">
      <router-link class="btn btn-dark" :to="{name: 'Promocode'}">
        Промокоды
      </router-link>
    </template>
    <template v-if="isPage.notesDrafts()">
      <router-link class="btn btn-dark" :to="{name: 'Notes'}">
        Заметки
      </router-link>
    </template>
    <template v-if="isPage.articlesDrafts()">
      <router-link class="btn btn-dark" :to="{name: 'PostArticles'}">
        Статьи
      </router-link>
    </template>
  </span>
</template>

<script>
import {defineComponent, reactive, watch} from "vue"
import PostPermission from "@/modules/post/services/Permission"
import PermissionsGroup from "@/components/permissions_group/Index"
import {editorRoleId} from "@/modules/auth/services/role"
import Helper from "@/services/Helper";
import Permission from "@/modules/users/services/Permission";

export default defineComponent({
  name: "Actions",
  components: {
    PermissionsGroup,
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    let fields = reactive(getFields())

    watch(() => props.payload, () => {
      updateFields(props.payload)
    }, { immediate: true })

    async function updateFields(query) {
      fields.channel_id = query.channel_id
      fields.page_name = query.page_name
    }

    function getFields() {
      return {
        channel_id: null,
        page_name: null,
      }
    }

    let isPage = {
      posts: () => {
        return fields.page_name === "posts"
      },
      notes: () => {
        return fields.page_name === "notes"
      },
      promocode: () => {
        return fields.page_name === "promocode"
      },
      articles: () => {
        return fields.page_name === "articles"
      },
      postsDrafts: () => {
        return fields.page_name === "posts_drafts"
      },
      articlesDrafts: () => {
        return fields.page_name === "articles_drafts"
      },
      promocodeDrafts: () => {
        return fields.page_name === "promocode_drafts"
      },
      notesDrafts: () => {
        return fields.page_name === "notes_drafts"
      },
    }

    function isShowCreateBtn() {
      return PostPermission.isCreate(fields.channel_id)
    }

    function isShowPermissionBtn() {
      return PostPermission.isShowPermissionBtn()
    }

    function isShowTagsBtn() {
      return Permission.hasPermissions("admin_post_tags");
    }

    let functions = {
      getTypeId: () => {
        if (fields.page_name === "promocode") {
          return 7
        }

        if (fields.page_name === "notes") {
          return 5
        }

        if (fields.page_name === "articles") {
          return 15
        }

        return 6
      },
    }

    function isSiteChannel() {
      return Helper.inArray([fields.channel_id], [1])
    }

    function isShowDropDownInCreateBtn() {
      return isSiteChannel()
    }

    return {
      isPage,
      isShowCreateBtn,
      isShowPermissionBtn,
      isShowTagsBtn,
      editorRoleId,
      fields,
      functions,
      isShowDropDownInCreateBtn,
    }
  },
})
</script>

<style scoped src="./css/style.css" />
